import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { SharedFileRequestStatus } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { WSPosterProps } from "@wingspanhq/fe-component-library";
import { ValidationProgress } from "../../components/ValidationProgress";
import { UploadNewFileInstructions } from "../../components/UploadNewFileInstructions";
import React from "react";
import { selectorIsRequirementReadyToUploadFile } from "../../../../selectors/selectorIsRequirementReadyToUploadFile";
import { getSharedFileIsValidatingActive } from "../helpers/getSharedFileIsValidatingActive";
import { selectorSharedFileExtractedFields } from "../../../../selectors/selectorSharedFileExtractedFields";
import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";

export const payerSharedFileRenderCardDescription = (
  requirement: IRequirementResponse,
  sharedFile?: ISharedFileRequestResponse
) => {
  const signedDocumentDescriptions: Record<
    SharedFileRequestStatus,
    WSPosterProps
  > = {
    [SharedFileRequestStatus.PendingUpload]: {
      type: "documents",
      title: "File not uploaded",
      description: "Waiting for you to upload a file."
    },
    [SharedFileRequestStatus.PendingSubmission]: {
      type: "documents",
      title: "Validation has failed",
      description: "You have few attempts to try to upload the file again."
    },
    [SharedFileRequestStatus.Processing]: {
      type: "documents",
      title: "Validation in progress",
      description: "Your file is being validated. This may take a few minutes."
    },
    [SharedFileRequestStatus.Failed]: {
      type: "documents",
      title: "File uploading has failed",
      description: "Something went wrong while uploading the file."
    },
    [SharedFileRequestStatus.Complete]: {
      type: "done",
      title: "Your file upload is complete",
      description: "You can download the file below."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: sharedFile?.status || SharedFileRequestStatus.PendingUpload,
    documentStatuses: signedDocumentDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document was uploaded",
      description:
        "The document was uploaded. The requirement now requires approval."
    },
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect your eligibility for related engagements."
    },
    approvedStatus: null,
    customContent: getSharedFileIsValidatingActive(sharedFile) ? (
      <ValidationProgress jobs={sharedFile?.jobs} />
    ) : selectorSharedFileExtractedFields(sharedFile) ? (
      <EmptyComponent />
    ) : selectorIsRequirementReadyToUploadFile(requirement, sharedFile) ? (
      <UploadNewFileInstructions
        status={sharedFile?.status}
        sharedFileRequestSettingsId={sharedFile?.sharedFileRequestSettingsId!}
        contextType={sharedFile?.contextType}
        requirementId={requirement.requirementId}
      />
    ) : null
  });
};
